var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiniİnstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_268",
    "data-name": "Group 268",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.973,
    height: 17.973,
    viewBox: "0 0 17.973 17.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 17.973,
    height: 17.973,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_268-2",
    "data-name": "Group 268",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M12.785,0h-7.6A5.188,5.188,0,0,0,0,5.188v7.6a5.188,5.188,0,0,0,5.188,5.188h7.6a5.188,5.188,0,0,0,5.188-5.188v-7.6A5.188,5.188,0,0,0,12.785,0m3.532,12.919a3.444,3.444,0,0,1-3.444,3.444H5.1a3.444,3.444,0,0,1-3.444-3.444V5.143A3.444,3.444,0,0,1,5.1,1.7h7.775a3.444,3.444,0,0,1,3.444,3.444Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M90.776,87a4.663,4.663,0,1,0,4.663,4.663A4.663,4.663,0,0,0,90.776,87m0,7.686A3.023,3.023,0,1,1,93.8,91.665a3.023,3.023,0,0,1-3.023,3.023",
    transform: "translate(-81.79 -82.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M254.44,61.829a1.086,1.086,0,1,0,1.086,1.086,1.086,1.086,0,0,0-1.086-1.086",
    transform: "translate(-240.635 -58.725)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniİnstagram);
export default __webpack_public_path__ + "static/media/mini-instagram.5d25042e131dee279f193b3efafc1d30.svg";
export { ForwardRef as ReactComponent };